<script setup>
import { ref, toRefs, onMounted } from 'vue'
import BaseTextInput from '@/src/vueComponent/BaseTextInput.vue'
import BaseSelect from '@/src/vueComponent/BaseSelect.vue'
import { ClearOutlined, SearchOutlined } from '@ant-design/icons-vue'

const props = defineProps({
  applicant: {
    type: Array
  },
  target: {
    type: Array
  }
})

const { applicant, target } = toRefs(props)
const applicantList = ref([])
const targetList = ref([])

const searchInfo = ref({
  feedback_code: '',
  lot_no: '',
  applicant: '',
  target: '',
  category: ''
})

const handleApplicantSelect = (applicant) => {
  searchInfo.value.applicant = applicant
  if (applicant === 'Jsw0' && searchInfo.value.target) {
    searchInfo.value.target = ''
  }
}

const handleTargetSelect = (target) => {
  searchInfo.value.target = target
  if (target === 'Jsw0' && searchInfo.value.applicant) {
    searchInfo.value.applicant = ''
  }
}

const categoryList = ref(
  Object.entries(I18n.t('enumerize.quality_feedback.state')).map(([value, label]) => ({
    value,
    label
  }))
)
categoryList.value.unshift({ value: 'all', label: '全部' }) // Add 'all'

onMounted(() => {
  const searchParams = new URLSearchParams(window.location.search)
  searchInfo.value.feedback_code = searchParams.get('feedback_code')
  searchInfo.value.lot_no = searchParams.get('lot_no')
  searchInfo.value.applicant = searchParams.get('applicant')
  searchInfo.value.target = searchParams.get('target')
  searchInfo.value.category = searchParams.get('category')

  if (searchInfo.value.category === null) {
    searchInfo.value.category = 'all'
  }

  applicantList.value = applicant.value.map((company) => ({
    value: `${company.type}${company.id}`,
    label: company.name
  }))

  targetList.value = target.value.map((company) => ({
    value: `${company.type}${company.id}`,
    label: company.name
  }))
})
</script>

<template>
  <form class="min-w-[248px] p-4" action="/quality_feedbacks" accept-charset="UTF-8" method="get">
    <div class="mb-2">
      <BaseTextInput
        :label="'單號'"
        :name="'feedback_code'"
        v-model="searchInfo.feedback_code"
      ></BaseTextInput>
    </div>
    <div class="mb-2">
      <BaseTextInput
        :label="'批號／料號'"
        :name="'lot_no'"
        v-model="searchInfo.lot_no"
      ></BaseTextInput>
    </div>
    <div class="mb-2">
      <BaseSelect
        :label="'發起人'"
        :name="'applicant'"
        :optionList="applicantList"
        :optionsSelected="searchInfo.applicant"
        @select="handleApplicantSelect($event)"
      />
    </div>
    <div class="mb-2">
      <BaseSelect
        :label="'對象'"
        :name="'target'"
        :optionList="targetList"
        :optionsSelected="searchInfo.target"
        @select="handleTargetSelect($event)"
      />
    </div>
    <div class="mb-2">
      <BaseSelect
        :label="'類別'"
        :name="'category'"
        :optionList="categoryList"
        :optionsSelected="searchInfo.category"
        @select="searchInfo.category = $event"
      />
    </div>
    <div class="mb-2 flex justify-between gap-3 py-3">
      <a href="/quality_feedbacks" class="btn btn-ghost text-xl">
        <ClearOutlined />
        清空
      </a>
      <button
        type="submit"
        class="block flex-1 rounded-md border-scp-royal-blue bg-scp-royal-blue p-3 text-center text-xl font-semibold text-white hover:bg-blue-800"
      >
        <SearchOutlined />
        查詢
      </button>
    </div>
  </form>
</template>
